module.exports = __webpack_public_path__ + "static/smile-a8840978baef36ce7a0a019ca402fc53.jpg";